<script setup>
import {defineEmits, defineProps} from "vue";
import HeaderDeDados from "./HeaderDeDados.vue";
import BodyDeDados from "./BodyDeDados.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dados",
    "dadosOriginais",
    "stateDadosOriginais",
    "gerandoPagamentos",
]);

const emits = defineEmits([
    "alteraVisualizandoDado",
    "alteraLiberandoDado",
    "alteraAprovandoDado",
    "alteraGerandoPagamentos",
    "alteraBaixandoDado",
]);

//==================================================================//
//==================== Altera Visualizando Dado ====================//
//==================================================================//

const alteraVisualizandoDado = (update = {})=>{

    emits('update:alteraVisualizandoDado',update);

};

//==================================================================//
//====================== Altera Liberando Dado =====================//
//==================================================================//

const alteraLiberandoDado = (update = {})=>{

    emits('update:alteraLiberandoDado',update);

};

//==================================================================//
//====================== Altera Aprovando Dado =====================//
//==================================================================//

const alteraAprovandoDado = (update = {})=>{

    emits('update:alteraAprovandoDado',update);

};

//==================================================================//
//=================== Altera Gerando Pagamento =====================//
//==================================================================//

const alteraGerandoPagamentos = (update = {})=>{

    emits('update:alteraGerandoPagamentos',update);

};

//==================================================================//
//======================= Altera Baixando Dado =====================//
//==================================================================//

const alteraBaixandoDado = (update = {})=>{

    emits('update:alteraBaixandoDado',update);

};

</script>

<template>

    <div class="c-table-wrapper">

        <div class="c-table">

            <HeaderDeDados
                :dados="props?.dados"
            ></HeaderDeDados>

            <BodyDeDados
                :controlesDesativados="props?.controlesDesativados"
                :dados="props?.dados"
                :dadosOriginais="props?.dadosOriginais"
                :stateDadosOriginais="props?.stateDadosOriginais"
                :gerandoPagamentos="props?.gerandoPagamentos"
                @update:alteraVisualizandoDado="alteraVisualizandoDado"
                @update:alteraLiberandoDado="alteraLiberandoDado"
                @update:alteraAprovandoDado="alteraAprovandoDado"
                @update:alteraGerandoPagamentos="alteraGerandoPagamentos"
                @update:alteraBaixandoDado="alteraBaixandoDado"
            ></BodyDeDados>

        </div>

    </div>

</template>

<style scoped>

/*==================================================================*/
/*============================ Table ===============================*/
/*==================================================================*/

.c-table-wrapper{
    overflow: hidden !important;
    width: calc(100vw - 110px);
    padding: 12px !important;
}

.c-table{
    display: grid;
    grid-template-columns: max-content max-content max-content max-content max-content max-content  max-content max-content max-content max-content max-content max-content max-content max-content max-content auto;
    overflow: auto;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    border-radius: 5px;
}


</style>
